import { Flex, Skeleton } from "@mantine/core";
import listStyles from "../AreaList/AreaList.module.css";
import { AreaRowsSkeleton } from "../AreaList/skeleton";
import panelStyles from "../AreaPanel/AreaPanel.module.css";
import styles from "./AreasTab.module.css";

/** Cabeçalho do painel da área (nome e linha de apoio) esperando os dados. */
export function AreaPanelSkeleton() {
  return (
    <div
      className={panelStyles.panel}
      data-testid="area-panel-skeleton">
      <Flex
        direction="column"
        gap={8}>
        <Skeleton
          height={20}
          width={180}
        />
        <Skeleton
          height={12}
          width={220}
        />
      </Flex>
    </div>
  );
}

/**
 * Esqueleto da aba Áreas no formato da lista + painel: o título "Áreas" é
 * texto real; contagem, botão, busca, filtro, linhas e o cabeçalho do painel
 * esperam os dados. Sem saber ainda se o setor tem áreas, a forma é a da
 * lista (a mais comum depois da primeira área).
 */
export function AreasTabSkeleton() {
  return (
    <div
      className={styles.root}
      data-testid="areas-tab-skeleton">
      <section className={listStyles.list}>
        <div className={listStyles.header}>
          <div className={listStyles.titleRow}>
            <div className={listStyles.titleBlock}>
              <div className={listStyles.title}>Áreas</div>
              <Skeleton
                height={12}
                width={64}
                mt={4}
              />
            </div>
            <Skeleton
              height={30}
              width={96}
              radius="sm"
            />
          </div>
          <Skeleton
            height={36}
            radius="md"
          />
          {/* Altura do FilterChip: 12.5px × 1.55 + 6px + 6px + borda. */}
          <Skeleton
            height={33}
            width={64}
            radius="xl"
          />
        </div>
        <AreaRowsSkeleton />
      </section>
      <AreaPanelSkeleton />
    </div>
  );
}
